import React from 'react'
const newlinesToDiv = (string) => <>{string.split('\n').map(s => <div>{s}</div>)}</>

export default {newlinesToDiv}